export const SET_CITY = 'SET_CITY'

export const setCity = value => ({
    type: SET_CITY,
    value});



// WEBPACK FOOTER //
// ./src/actions/index.js